import {useSelector} from 'react-redux';


import {userSelectors} from '../index';


function useUser() {

    return useSelector(userSelectors.getUser);
}


export default useUser;
